import React from 'react';

import { Text } from '@reckon-web/text';
import { plural } from '@reckon-web/utils';
import { LoadingDots } from '@reckon-web/loading';

import { getTargetType } from '../helper';
import { useGetEntitiesByIds } from '../../../data/useGetEntitiesByIds';
import { GetActivityItem } from '../../../data/useGetActivities';

interface IActivityCategoryEntitiesAdded {
  activity: GetActivityItem;
}

// Activity Category EntitiesAdded = 4
export const ActivityCategoryEntitiesAdded = ({
  activity,
}: IActivityCategoryEntitiesAdded) => {
  // list of entity ids in afterData.Entities but not in beforeData.Entities (comma delimited)
  const rawEntityIds = !activity.propertyNew
    ? []
    : activity.propertyNew.split(',');

  const { data, loading, error } = useGetEntitiesByIds({
    variables: { cloudIds: rawEntityIds },
  });

  if (loading) {
    return <LoadingDots size="small" label="loading entities added" />;
  }

  if (error || !data) {
    return <Text>Error</Text>;
  }

  const firstEntitiesFormatted = () => {
    if (data.length === 0) {
      return '';
    }
    if (data.length === 1) {
      return data[0].name;
    }
    // slice is EXCLUSIVE of the end
    return data
      .slice(0, -1)
      .map((x) => x.name)
      .join(', ');
  };

  const lastEntityFormatted =
    data.length === 0 ? '' : data[data.length - 1].name;

  const singleOrPlural = plural(data.length, 'client', 'clients', false);

  return (
    <Text size="small">
      Added {singleOrPlural}{' '}
      <Text inline size="small" weight="semibold">
        {firstEntitiesFormatted()}
      </Text>
      {data.length > 1 && ' and '}
      {data.length > 1 && (
        <Text inline size="small" weight="semibold">
          {lastEntityFormatted}
        </Text>
      )}{' '}
      to the {getTargetType(activity.targetType)}
    </Text>
  );
};
